// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/index.less
// module id = 1240
// module chunks = 0